module.exports = "/static-assets/_next/static/images/frog-trending-arrows-5a6dcdedfa3498fa551b9a4a9b7a80b6.png";